// extracted by mini-css-extract-plugin
export default {"labelTd":"ThongTinDonvi_labelTd__iTgF4","tr":"ThongTinDonvi_tr__iDUvl"};